import {Box, Flex, Image, Text} from '@chakra-ui/react';
import {TablerPlayerPlay} from '../../icons';
import type {UniversityVideo} from '../../services/universityService';

// Thumbnail / poster visual shared by the /learn cards, the contextual tip,
// and the player modal's placeholder frame. Real posters render as images;
// placeholders get a branded opalite gradient so an unrecorded video still
// looks designed rather than broken.
const UniversityPoster = ({
  video,
  iconSize = 22,
  showComingSoon = false,
  ...rest
}: {
  video: UniversityVideo;
  iconSize?: number;
  showComingSoon?: boolean;
} & Record<string, any>) => {
  if (video.posterUrl) {
    return (
      <Box position="relative" overflow="hidden" {...rest}>
        <Image
          src={video.posterUrl}
          alt=""
          w="100%"
          h="100%"
          objectFit="cover"
        />
        <PlayBadge iconSize={iconSize} />
      </Box>
    );
  }

  return (
    <Flex
      position="relative"
      align="center"
      justify="center"
      overflow="hidden"
      bgGradient="linear(135deg, opalite.500, opalite.700)"
      {...rest}
    >
      {/* Soft radial glow so the placeholder reads as an intentional surface */}
      <Box
        position="absolute"
        inset={0}
        bgGradient="radial(circle at 30% 20%, whiteAlpha.300, transparent 55%)"
        pointerEvents="none"
      />
      <PlayBadge iconSize={iconSize} />
      {showComingSoon && (
        <Text
          position="absolute"
          bottom={2}
          right={2}
          bg="blackAlpha.500"
          color="white"
          fontSize="2xs"
          fontWeight="medium"
          textTransform="uppercase"
          letterSpacing="0.05em"
          borderRadius="md"
          px={2}
          py={0.5}
        >
          Coming soon
        </Text>
      )}
    </Flex>
  );
};

const PlayBadge = ({iconSize}: {iconSize: number}) => (
  <Flex
    position="absolute"
    top="50%"
    left="50%"
    transform="translate(-50%, -50%)"
    align="center"
    justify="center"
    boxSize={`${iconSize * 2}px`}
    borderRadius="full"
    bg="whiteAlpha.900"
    color="opalite.700"
    boxShadow="0 4px 14px rgba(7, 0, 77, 0.25)"
    pointerEvents="none"
  >
    <TablerPlayerPlay size={iconSize} style={{marginLeft: '2px'}} />
  </Flex>
);

export default UniversityPoster;
